import React from 'react';
import './ConversationHistory.css';

function ConversationHistory({ messages }) {
  const userMessages = messages.filter(m => m.role === 'user');
  const recent = userMessages.slice(-3).reverse();

  return (
    <div className="conversation-history">
      <h3 className="history-title">Conversation</h3>

      {userMessages.length > 0 ? (
        <>
          <div className="message-count">
            Messages in this session: <strong>{userMessages.length} queries</strong>
          </div>

          {recent.length > 0 && (
            <div className="recent-queries">
              <h4 className="recent-title">Recent queries:</h4>
              <ul className="queries-list">
                {recent.map((msg, index) => {
                  const preview = msg.content.length > 50
                    ? msg.content.substring(0, 50) + '...'
                    : msg.content;
                  return (
                    <li key={index} className="query-item">{preview}</li>
                  );
                })}
              </ul>
            </div>
          )}
        </>
      ) : (
        <div className="no-messages">
          No messages yet. Start a conversation!
        </div>
      )}
    </div>
  );
}

export default ConversationHistory;
